import { create } from 'zustand';
import MuvikaService from './../services/muvika';
import messageStore from './message';

const initialState = {
  isSet: false,
  isWaiting: false,
  isFinished: false,
  isAllLanguageFiltersSet: true,
  isAllGenreFiltersSet: true,
  isAllDecadeFiltersSet: true,
  isAllAlphabetFiltersSet: true,
  isOrderBySongTitleSet: true,
  isOrderByArtistNameSet: false,
  isOrderByPopularitySet: false,
  filterLanguages: {},
  filterGenres: {},
  filterDecades: {},
  filterAlphabets: {},
  totalCount: 0,
  currentPage: 1,
  tracks: null,
  latestReqId: -1
};

const catalogStore = create((set, get) => ({
  ...initialState,
  reset: () => { 
    set(initialState)
  },
  getTracks: (sessionToken, pageSize) => {
//console.log(sessionToken)
    set({ currentPage: 1, tracks: null, isSet: false, isWaiting: true, isFinished: false });
    let orderBy = "title";
    let alphabetKey = "title";
    if (get().isOrderByArtistNameSet) {
      orderBy = "artist";
      alphabetKey = "artist";
    }
    if (get().isOrderByPopularitySet) {
      orderBy = "popularity";
    }
    let langFilters = get().isAllLanguageFiltersSet ? [] : get().filterLanguages;
    let genreFilters = get().isAllGenresFiltersSet ? [] : get().filterGenres;
    let decadeFilters = get().isAllDecadesFiltersSet ? [] : get().filterDecades;
    let useAlphabets = get().isOrderByPopularitySet || get().isAllAlphabetsFiltersSet ? [] : get().filterAlphabets;
    let items = MuvikaService.createBrowseParameters(
      langFilters,
      genreFilters,
      decadeFilters,
      useAlphabets,
      alphabetKey);
    MuvikaService.getTracks(sessionToken, pageSize, 1, items, orderBy)
      .then(function (res) {
        //console.log(res)
        if (res.data.error) {
          set({ isSet: false, tracks: [], totalCount: 0, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let latestReqId = get().latestReqId;
          let newReqId = res.data.request_id;
          let tracksList = res.data.data.items;
          if(newReqId > latestReqId){
            set({ isSet: true, tracks: tracksList, totalCount: res.data.data.items_total, isWaiting: false, latestReqId: newReqId });
            if (tracksList.length < pageSize) {
              set({ isFinished: true });
            }
          }
        }
      })
      .catch(function(){});
  },
  getTracksMore: (sessionToken, pageSize) => {
if (!get().isWaiting) {
      let page = get().currentPage + 1;
      set({ currentPage: page, isSet: false, isWaiting: true });
      let orderBy = "title";
      let alphabetKey = "title";
      if (get().isOrderByArtistNameSet) {
        orderBy = "artist";
        alphabetKey = "artist";
      }
      if (get().isOrderByPopularitySet) {
        orderBy = "popularity";
      }
      let langFilters = get().isAllLanguageFiltersSet ? [] : get().filterLanguages;
      let genreFilters = get().isAllGenresFiltersSet ? [] : get().filterGenres;
      let decadeFilters = get().isAllDecadesFiltersSet ? [] : get().filterDecades;
      let useAlphabets = get().isOrderByPopularitySet || get().isAllAlphabetsFiltersSet ? [] : get().filterAlphabets;
      let items = MuvikaService.createBrowseParameters(
        langFilters,
        genreFilters,
        decadeFilters,
        useAlphabets,
        alphabetKey);
      MuvikaService.getTracks(sessionToken, pageSize, page, items, orderBy)
        .then(function (res) {
          if (res.data.error) {
            set({ isSet: false, tracks: [], isWaiting: false });
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            let latestReqId = get().latestReqId;
            let newReqId = res.data.request_id;
            let tracks = get().tracks;
            let tracksMore = res.data.data.items;
            if(newReqId > latestReqId){
              if (tracksMore.length == 0) {
                set({ isFinished: true });
              }
              tracks = tracks.concat(tracksMore);
              set({ isSet: true, tracks: tracks, totalCount: res.data.data.items_total, isWaiting: false, latestReqId: newReqId });
            }
          }
        })
        .catch(function(){});
    }
  },
  setLanguageFilter: (id, isOn) => {
let filterLanguages = get().filterLanguages;
    filterLanguages[id] = isOn;
    set({ isAllLanguageFiltersSet: false, filterLanguages: { ...filterLanguages } });
  },
  setAllLanguageFilters: (trackLanguages) => {
let filterLanguages = {};
    trackLanguages.forEach(function (lang) {
      filterLanguages[lang.id] = false;
    });
    set({ isAllLanguageFiltersSet: true, filterLanguages: filterLanguages });
  },
  setGenreFilter: (id, isOn) => {
let filterGenres = get().filterGenres;
    filterGenres[id] = isOn;
    set({ isAllGenreFiltersSet: false, filterGenres: { ...filterGenres } });
  },
  setAllGenreFilters: (trackGenres) => {
let filterGenres = {};
    trackGenres.forEach(function (genre) {
      filterGenres[genre.id] = false;
    });
    set({ isAllGenreFiltersSet: true, filterGenres: filterGenres });
  },
  setDecadeFilter: (id, isOn) => {
let filterDecades = get().filterDecades;
    filterDecades[id] = isOn;
    set({ isAllDecadeFiltersSet: false, filterDecades: { ...filterDecades } });
  },
  setAllDecadeFilters: (trackDecades) => {
let filterDecades = {};
    trackDecades.forEach(function (decade) {
      filterDecades[decade] = false;
    });
    set({ isAllDecadeFiltersSet: true, filterDecades: filterDecades });
  },
  setAlphabetFilter: (id, isOn) => {
let filterAlphabets = {};
    filterAlphabets[id] = isOn;
    set({ isAllAlphabetFiltersSet: false, filterAlphabets: { ...filterAlphabets } });
  },
  setAllAlphabetFilters: (trackAlphabets) => {
let filterAlphabets = {};
    trackAlphabets.forEach(function (alphabet) {
      filterAlphabets[alphabet] = false;
    });
    set({ isAllAlphabetFiltersSet: true, filterAlphabets: filterAlphabets });
  },
  setOrderBySongTitle: () => { 
    set({ isOrderBySongTitleSet: true, isOrderByArtistNameSet: false, isOrderByPopularitySet: false });
  },
  setOrderByArtistName: () => { 
    set({ isOrderBySongTitleSet: false, isOrderByArtistNameSet: true, isOrderByPopularitySet: false });
  },
  setOrderByPopularity: () => { 
    set({ isOrderBySongTitleSet: false, isOrderByArtistNameSet: false, isOrderByPopularitySet: true });
  }
}));

export default catalogStore;